import React, { useState, useEffect } from "react";
import ImageViewPlayer from "components/ImageViewPlayer";
import ShowOnVisible from "components/ShowOnVisible";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import ImageRecorder from "components/AttachmentSelection/ImageRecorder";
import ButtonWithProgress from "components/ButtonWithProgress";
import { useTimelineContext } from "store/contexts/timelineContext";
import AttachmentSelection from "components/AttachmentSelection/AttachmentSelection";
import AttachmentPreview from "components/AttachmentPreview/AttachmentPreview";
import ThoughtDialog from "components/ThoughtDialog";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import { ReactComponent as CameraIcon } from "assets/img/icons/camera-img.svg";
import { ReactComponent as BinIcon } from "assets/img/icons/bin.svg";
import Button from "components/CustomButton";

var styles = {
  imageVideoContainer: {
    width: "100%",
    padding: "15px",
    background: "#f2f2f2",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  responseOptions: {
    display: "flex",
    gap: "10px",
    justifyContent: "center",
  },
  cancelImageRecorder: {
    width: "300px",
    maxWidth: "80vw",
    backgroundColor: "#1e242c",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: "white",
    padding: "5px 0",
  },
  cancelIcon: {
    marginLeft: "12px",
    cursor: "pointer",
    width: "25px",
  },
  showImageCapture: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  buttonContainer: {
    position: "absolute",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    textAlign: "center",
    alignItems: "center",
    bottom: "50px",
    gap: "10px",
  },
  binIcon: {
    cursor: "pointer",
    width: "35px",
    height: "35px",
    background: "#434343",
    fill: "white",
    borderRadius: "50%",
    padding: "5px",
    boxShadow: "0 1px 8px 0 rgb(0 0 0 / 20%), 0 4px 23px 0 rgb(0 0 0 / 19%)",
  },
  responseOptionText: {
    fontSize: "16px",
    fontWeight: 400,
    color: "white",
  },
  imageSubmitText: {
    marginBottom: "18px",
    fontSize: "18px",
    marginTop: "5px",
    fontWeight: "400",
  },
  imageSubmitedText: {
    marginBottom: "0px",
    fontSize: "18px",
    marginTop: "5px",
    fontWeight: "400",
  },
};

export default ({ post }) => {
  const classes = styles;
  const [slideshow, setSlideShow] = useState(null);
  const [isCapture, setCapture] = useState(false);
  const [showCameraOption, setShowCameraOption] = useState(false);
  const [initialImageResponse] = useState({
    media: post?.data.media,
    user: post?.user,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [yourResponse, setYourResponse] = useState(false);
  const { updatePost } = useTimelineContext();
  const [slideData, setSlideData] = useState(null);
  const [webCamData, setWebCamData] = useState();
  const [selectAttachment, setSelectAttachment] = useState(false);
  const [caption, setCaption] = useState();

  useEffect(() => {
    if (!slideshow) {
      return;
    }

    updatePost({
      ...post,
      data: {
        ...slideshow,
      },
    });

    // eslint-disable-next-line
  }, [slideshow]);

  const height = post?.data?.published_at || isCapture ? "400px" : "350px";

  const onLoad = async () => {
    const response = await TeamService.getSlideShow(post.team_id, post?.id);
    setSlideShow(response.data.data);
  };

  const submitSlideShow = async () => {
    setIsSubmitting(true);
    try {
      await TeamService.postSlideshowResponse(
        post.team_id,
        post?.data?.id,
        slideData,
        caption
      );

      if (post?.data?.responses_count + 1 === post?.data?.max_responses_count) {
        await onLoad();
      }

      const postCopy = { ...post };

      postCopy.data.responses_count += 1;
      updatePost(postCopy);
      setYourResponse(true);
      setSlideData(null);

      if (webCamData) {
        webCamData.dispose();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const onAttachmentSelected = (data) => {
    setSlideData(data);
    setSelectAttachment(true);
  };

  const clearAttachment = () => {
    setSelectAttachment(false);
    setSlideData(null);
    setShowCameraOption(false);
  };

  const cancelImageData = () => {
    setCapture(false);
    if (slideData) {
      setSlideData(null);
    }
    if (webCamData) {
      webCamData.dispose();
    }
  };

  return (
    <ShowOnVisible
      height={height}
      backgroundColor="black"
      maxHeight="700px"
      containerClass={"containerClass"}
    >
      {!post?.data?.published_at && (
        <>
          {!post?.data?.is_responded && (
            <>
              {!Boolean(isCapture) && !Boolean(selectAttachment) && (
                <>
                  <div style={classes.imageVideoContainer}>
                    <p style={classes.imageSubmitText}>
                      {post?.data?.responses_count} of{" "}
                      {post?.data?.max_responses_count} Images submitted
                    </p>
                    {!showCameraOption && (
                      <Button
                        buttonStyle={{
                          width: "200px",
                        }}
                        onClick={() => setShowCameraOption(!showCameraOption)}
                        type="button"
                        buttonClass={"grad_btn join-btn"}
                        name="Submit Your Response"
                      />
                    )}
                    {showCameraOption && (
                      <div style={{ marginBottom: "5px" }}>
                        <div style={classes.responseOptions}>
                          <AttachmentSelection
                            videoSpanClass={null}
                            videoClass="responseOption"
                            videoTextClass="responseCaptureOption"
                            attachmentTextClass="responseCaptureOption"
                            videoText={
                              <div style={classes.responseOptionText}>
                                Capture an image
                              </div>
                            }
                            attachmentText={
                              <div style={classes.responseOptionText}>
                                Upload an image
                              </div>
                            }
                            attachmentClass="responseOption"
                            VideoAttachmentIcon={CameraIcon}
                            type="image"
                            videocamIconColor={"white"}
                            attachmentIconColor={"white"}
                            classAttatchment={"selectAttachmentIcon"}
                            showSelectors={false}
                            onChange={onAttachmentSelected}
                            accepted={[".png", ".jpg", ".jpeg"]}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  {!selectAttachment && (
                    <ImageViewPlayer
                      imageResponses={[initialImageResponse]}
                      postPublished={post.data.published}
                      post={post}
                    />
                  )}
                </>
              )}
              {Boolean(selectAttachment) && !yourResponse && (
                <div style={{ width: "100%" }}>
                  <div style={classes.buttonContainer}>
                    {slideData && (
                      <BinIcon
                        onClick={clearAttachment}
                        style={classes.binIcon}
                      />
                    )}
                    {slideData && (
                      <ButtonWithProgress
                        isSubmitting={isSubmitting}
                        isValid={slideData}
                        buttonWithProgressClass={"grad_btn join-btn"}
                        color="primaryGradient"
                        onClick={submitSlideShow}
                        style={{
                          width: "170px",
                          zIndex: "100",
                          top: "0",
                          right: "3px",
                        }}
                        initialText="Submit Response"
                      />
                    )}
                    {slideData && (
                      <ThoughtDialog
                        caption={caption}
                        initialResponse={post}
                        setCaption={setCaption}
                      />
                    )}
                  </div>
                  <AttachmentPreview
                    removePreviewAttachment={"removeAttachmentIcon"}
                    imageStyle={{
                      maxHeight: "inherit",
                      maxWidth: "inherit",
                      minHeight: "inherit",
                      minWidth: "inherit",
                      objectFit: "cover",
                      width: "100%",
                    }}
                    commentAttachmentPreview={"teamAttachmentPreview"}
                    attachment={slideData}
                    clearAttachment={clearAttachment}
                  />
                </div>
              )}
              {Boolean(isCapture) && !yourResponse && (
                <div style={classes.showImageCapture}>
                  {slideData && (
                    <ButtonWithProgress
                      isSubmitting={isSubmitting}
                      isValid={slideData}
                      buttonWithProgressClass={"grad_btn join-btn"}
                      color="primaryGradient"
                      onClick={submitSlideShow}
                      style={{
                        position: "absolute",
                        zIndex: "100",
                        top: "0",
                        right: "3px",
                      }}
                      initialText="Submit Response"
                    />
                  )}
                  {slideData && (
                    <ThoughtDialog
                      caption={caption}
                      initialResponse={post}
                      setCaption={setCaption}
                    />
                  )}
                  <div style={classes.cancelImageRecorder}>
                    <CancelIcon
                      style={classes.cancelIcon}
                      onClick={cancelImageData}
                    />
                  </div>
                  <ImageRecorder
                    setWebCamData={setWebCamData}
                    disposeAfterRecording={false}
                    height={400}
                    width={-1}
                    onChange={(data) => setSlideData(data)}
                  />
                </div>
              )}
            </>
          )}
          {(Boolean(post?.data?.is_responded) || yourResponse) && (
            <>
              <div style={classes.imageVideoContainer}>
                <p style={classes.imageSubmitedText}>
                  {post?.data?.responses_count} of{" "}
                  {post?.data?.max_responses_count} Images submitted
                </p>
              </div>
              <ImageViewPlayer
                imageResponses={[initialImageResponse]}
                postPublished={post.data.published}
                post={post}
              />
            </>
          )}
        </>
      )}
      {post?.data?.published_at && (
        <>
          <img
            style={{ display: "none" }}
            src="dasd"
            alt="dummy"
            onError={onLoad}
          ></img>
          {!slideshow && <Loader />}
          {slideshow && (
            <ImageViewPlayer
              imageResponses={slideshow?.slideshow_responses}
              postPublished={post.data.published}
              post={post}
            />
          )}
        </>
      )}
    </ShowOnVisible>
  );
};
